import type { DirectiveBinding } from 'vue'

type ClickOutsideBinding = ((event: MouseEvent) => void) | { handler: (event: MouseEvent) => void }

type ClickOutsideElement = HTMLElement & {
  clickOutsideEvent?: (event: MouseEvent) => void
  clickOutsideDelay?: number
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('click-outside', {
    mounted(el: ClickOutsideElement, binding: DirectiveBinding<ClickOutsideBinding>) {
      const getHandler = () => {
        if (typeof binding.value === 'function') {
          return binding.value
        }
        return binding.value?.handler
      }

      el.clickOutsideEvent = function (event: MouseEvent) {
        const target = event.target
        if (target instanceof Node && !(el === target || el.contains(target))) {
          getHandler()?.(event)
        }
      }

      el.clickOutsideDelay = window.setTimeout(() => {
        document.addEventListener('click', el.clickOutsideEvent!)
      }, 0)
    },
    unmounted(el: ClickOutsideElement) {
      if (el.clickOutsideDelay) {
        clearTimeout(el.clickOutsideDelay)
      }
      if (el.clickOutsideEvent) {
        document.removeEventListener('click', el.clickOutsideEvent)
      }
    },
  })
})
